import { render, staticRenderFns } from "./SSO.vue?vue&type=template&id=e17511da&scoped=true"
import script from "./SSO.vue?vue&type=script&lang=js"
export * from "./SSO.vue?vue&type=script&lang=js"
import style0 from "./SSO.vue?vue&type=style&index=0&id=e17511da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e17511da",
  null
  
)

export default component.exports